<template>
  <div>
    <div class="vx-row">
      <vx-card title no-shadow card-border>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-end px-3">
              <span class="font-medium text-lg leading-none">{{
                $t("inventory.label.CreateNewContract")
              }}</span>
            </div>
            <vs-divider />
          </div>
        </div>
        <form>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <small class="date-label font-semibold">{{
                $t("inventory.label.ContractType")
              }}</small>
              <v-select
                label="typeData"
                v-model="contract.typeData"
                :options="typeData"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2 font-semibold"
              >
                <template v-slot:option="option">{{
                  option.typeData
                }}</template>
              </v-select>
              <!-- <vs-td :data="getDate(contract.requestedDate)">{{ getDate(contract.requestedDate) }}</vs-td> -->
              <vs-input
                :label="$t('inventory.label.RequestedBy')"
                class="w-full mb-2 font-semibold"
                v-model="contract.RequestedBy"
                @load="getMrnFalse()"
              />
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('inventory.label.ContractUnit')"
                class="w-full mb-2 font-semibold"
                v-model="contract.units"
              />
            </div>
          </div>
          <div class="vx-row float-right my-2">
            <div class="vx-col w-full">
              <vs-button class="mr-3 mb-2" @click="createContract">{{
                $t("inventory.label.Submit")
              }}</vs-button>
              <vs-button
                color="warning"
                type="border"
                class="mb-2"
                @click="resetForm"
                >{{ $t("inventory.label.Cancel") }}
              </vs-button>
            </div>
          </div>
        </form>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate/dist/vee-validate";
// import NProgress from 'nprogress/nprogress.js'
import { getMrnTemplate, getMrnFalse, getMrnTrue } from "@/http/inventory";

import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { mapState } from "vuex";

const contractEmptyObj = {
  typeData: "",
  officeData: "",
  requestedDate: "",
};

export default {
  data() {
    return {
      contract: contractEmptyObj,
      errorMessage: "",
      typeData: ["grv", "mrn"],
      officeData: [],
      itemMasterData: [],
      requestedDate: "",
      contracts: {},
    };
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  // mounted() {
  //     this.createContract()
  // },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    async getMrnTemplate() {
      try {
        const resp = await getMrnTemplate();
        this.contract = resp.data;
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
      }
    },
    async getMrnFalse() {
      try {
        const resp = await getMrnFalse();
        this.false = resp.data;
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
      }
    },
    async getMrnTrue() {
      try {
        const resp = await getMrnTrue();
        this.true = resp.data;
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
      }
    },
    async createContract() {
      // NProgress.start()
      this.submitted = true;
      this.contract = {
        subscriptionPeriod: this.contract.subscriptionPeriod,
        subscriptionType: this.contract.subscriptionType,
        units: this.contract.units,
      };
      try {
        const resp = await saveContract(this.contract);
        if (resp.data.resourceId && resp.data.resourceId) {
          this.$router.push("/setup");
          this.resetForm();
        }
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
        console.log("something went to wrong while creating contract:", e);
      }
    },
    resetForm() {
      this.contract = contractEmptyObj;
      this.contract.subscriptionPeriod = "";
      this.contract.subscriptionType = "";
      this.contract.units = "";
    },
  },
  watch: {},
  created() {
    this.getMrnTemplate();
  },
};
</script>
